import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/** In the fenced SG rehearsal this component never requests business data. */
export default function SingaporePreliveReady() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const exit = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <main className="login-wrap" data-testid="sg-prelive-ready">
      <section className="login-card">
        <div className="brand-mark">SG</div>
        <h1 className="login-title">Login Singapore berhasil</h1>
        <p className="login-sub">
          Pengujian autentikasi berhasil untuk {user?.name || "pengguna"}.
        </p>
        <p>
          Mode verifikasi terbatas. Impor Ginee, Purchase, Checker, Scan Out,
          Settlement, pembayaran, dan seluruh halaman operasional belum diaktifkan.
        </p>
        <button className="btn-primary" type="button" onClick={exit}>
          Keluar
        </button>
      </section>
    </main>
  );
}
